export class Expedientes_Detalle_Expediente_DTO {
    idAliado: number;
    id: number;
    asunto: string;
    concepto: string;
    fecha: Date;
}